import { cn } from '../../lib/utils'
import { ChevronRight } from 'lucide-react'

interface BreadcrumbItem {
  label: string
  onClick?: () => void
}

interface DrillBreadcrumbProps {
  items: BreadcrumbItem[]
  currentLabel: string
  className?: string
}

export function DrillBreadcrumb({ items, currentLabel, className }: DrillBreadcrumbProps) {
  return (
    <nav className={cn('flex items-center gap-1 text-xs', className)}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1">
          <button
            onClick={item.onClick}
            className={cn(
              'text-[var(--text-secondary,#94A3B8)] hover:text-[var(--accent,var(--accent))]',
              'transition-colors cursor-pointer',
            )}
          >
            {item.label}
          </button>
          <ChevronRight className="w-3 h-3 text-[var(--text-hint,#475569)]" />
        </span>
      ))}
      <span className="text-[var(--text-primary,#F0F2F5)] font-medium">
        {currentLabel}
      </span>
    </nav>
  )
}
